<template>
  <img
    :alt="realmName"
    :title="realmName"
    loading="lazy"
    class="max-h-[4.5rem] max-w-44 inline-block"
    decoding="async"
    style="color: transparent"
    :src="realmLogo"
  />
</template>

<script setup lang="ts">
// Props
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useUiStore } from "@common/stores";

// Variables
const uiStore = storeToRefs(useUiStore());

// Computed
const realmLogo = computed(() => {
  return uiStore.realmLogo.value;
});

const realmName = computed(() => {
  return uiStore.realm.value.name;
});
</script>
